var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar($event)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",[(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d00f7cbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/SidebarLink.vue
// module id = J6wH
// module chunks = 1